import { LayoutData_Banner_Position, Node_Type } from '@wix/ricos';
export const isPaywallNode = (node) => node.type === Node_Type.LAYOUT &&
    node.layoutData?.banner?.position === LayoutData_Banner_Position.PAYWALL;
//# sourceMappingURL=is-paywall-node.js.map